import { render, staticRenderFns } from "./form_alterar_senha.vue?vue&type=template&id=b03e033c"
import script from "./form_alterar_senha.vue?vue&type=script&lang=js"
export * from "./form_alterar_senha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports